"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _paypal = _interopRequireDefault(require("./paypal"));

var _twingle = _interopRequireDefault(require("./twingle"));

var _contexts = require("../app/contexts");

var _helpers = require("../box/helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function usePay(amount, isFdbkShown) {
  const openDonUrl = useDonationUrl(amount.val);
  const [twingleWidget, startTwingle] = (0, _twingle.default)(openDonUrl, isFdbkShown);
  const [paypalBtn, startPaypal] = (0, _paypal.default)(startTwingle);
  const onCtaClick = startPaypal || startTwingle || openDonUrl;
  return [paypalBtn, twingleWidget, onCtaClick];
}

var _default = usePay;
exports.default = _default;

function useDonationUrl(amountVal) {
  const {
    ctaTargetUrl
  } = (0, _react.useContext)(_contexts.Settings);
  const targetUrl = (0, _helpers.strOrFunc)(ctaTargetUrl, [amountVal]);
  if (!targetUrl) return null;
  return () => {
    window.open(targetUrl);
  };
}